import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to move lead(s) to another leads list.
export default class extends Controller {
  static get targets() {
    return ["modal", "frame"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedLeadIds: { type: Array, default: [] },
      numberOfLeads: { type: Number, default: 0 },
    }
  }

  // This action opens the modal to select the leads list to move the lead(s) to. The content of the modal is loaded
  // using the result of a submit of a temporary form.
  show({ params: { leadId, leadsListId, removeFromList } }) {
    let leadIds = leadId ? [leadId] : this.selectedLeadIdsValue

    const form = TempFormHelper.create(
      "/lead/bulk",
      "post",
      (form) => {
        TempFormHelper.addHiddenInput(form, "remove_from_list", removeFromList)

        if (leadsListId) {
          TempFormHelper.addHiddenInput(form, "leads_list_id", leadsListId)
        }

        if (leadIds.length > 0) {
          leadIds.forEach((leadId) => {
            TempFormHelper.addHiddenInput(form, "lead_ids[]", leadId)
          })
        } else {
          Object.entries(this.filtersValue).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((arrayValue) => {
                TempFormHelper.addHiddenInput(form, `${key}[]`, arrayValue)
              })
            } else {
              TempFormHelper.addHiddenInput(form, key, value)
            }
          })
        }
      },
      this.frameTarget,
    )

    form.requestSubmit()
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets
        .map((dataSet) => dataSet.leadId || dataSet.recordId)
        .filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
